import React, { ButtonHTMLAttributes } from 'react'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  text: string
  className?: string
  onClick: () => void
}

const FormExtraButton: React.FC<Props> = ({
  text,
  className,
  onClick,
  ...rest
}) => {
  return (
    <button
      className={`main-btn ${className || ''}`}
      onClick={onClick}
      {...rest}
    >
      {text}
    </button>
  )
}

export default FormExtraButton
